module.exports = __webpack_public_path__ + "img/sd-logo-white.7e70666e.png";